<template>
  <div class="basic">

    <span class="title">基本信息</span>
    <div class="basic-com">
      <el-descriptions class="margin-top" :size="size" :column="2" border>

        <template slot="extra" v-if="!companyId">
          <el-button size="mini" v-show="!isEdit" @click="edit()">编辑 <i
              class="el-icon-edit-outline el-icon--right"></i></el-button>
          <el-button size="mini" v-show="isEdit" @click="cancelEdit()">取消</el-button>
          <el-button size="mini" v-show="isEdit" type="success" @click="save()">保存</el-button>
        </template>

        <el-descriptions-item>
          <template slot="label">
            企业名称
          </template>
          <span>{{ companyData.name }}</span>
          <!-- <el-input v-else v-model="companyData.name" /> -->
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            统一社会信用代码
          </template>
          <span>{{ companyData.uniformSocialCreditCode }}</span>
          <!-- <el-input v-else v-model="companyData.uniformSocialCreditCode" /> -->
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            注册地址
          </template>
          <span v-if="!isEdit">{{ companyData.addr }}</span>
          <el-input v-else v-model="companyData.addr" />
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            行业类别
          </template>
          <span v-if="!isEdit">{{ companyData.industry2017s.map(i => i.industryName).join('，') }}</span>

          <el-cascader v-else placeholder="请选择行业类别" ref="industryCas" style="width: 100%;" v-model="industry2017s"
            :props="industriesProps" :options="industries" filterable @change="changeIndustry">
          </el-cascader>

        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            生产经营场所
          </template>
          <span v-if="!isEdit">{{ companyData.productionAddress }}</span>
          <el-input v-else v-model="companyData.productionAddress" />

        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            行业代码
          </template>
          <span v-if="!isEdit">{{ companyData.industryCode }}</span>
          <el-input v-else :disabled="true" v-model="companyData.industryCode" />

        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            危废管理联系人
          </template>
          <span v-if="!isEdit">{{ companyData.wasteContact }}</span>
          <el-input v-else v-model="companyData.wasteContact" />
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            联系电话
          </template>
          <span v-if="!isEdit">{{ companyData.mobile }}</span>
          <el-input v-else v-model="companyData.mobile" />
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            有效期限
          </template>
          <span v-if="!isEdit">{{ effDateTime }}</span>
          <el-date-picker style="width:100%" v-model="date" @change="dateChange" v-else type="daterange"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            许可证编号
          </template>
          <span v-if="!isEdit">{{ companyData.licenseNo }}</span>
          <el-input v-else v-model="companyData.licenseNo" />
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            经营类别
          </template>
          <span v-if="!isEdit">{{ companyData.businessCategory }}</span>
          <el-select @change="businessCategoryChange" v-model="businessCategory" collapse-tags multiple
            style="width: 100%;" placeholder="请选择经营类别" v-else>
            <el-option v-for="item in types" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            危废经营方式
          </template>
          <span v-if="!isEdit">{{ companyData.wasteManagementShow }}</span>

          <el-select v-model="companyData.wasteManagementChecked" multiple style="width: 100%;" placeholder="请选择危废经营方式"
            v-else @change="wasteManagementChange">
            <el-option v-for="item in wasteManagement" :key="item.Key" :label="item.Value" :value="item.Key">
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            经营能力（吨/年）
          </template>
          <span v-if="!isEdit">{{ companyData.businessAbility }}</span>
          <el-input v-else v-model="companyData.businessAbility" />
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            经度/纬度
          </template>
          <div style="display: flex;">
            <el-input v-model="companyData.lng" :disabled="!isEdit" style=" margin-right: 14px;" />
            <el-input v-model="companyData.lat" :disabled="!isEdit" style=" margin-right: 14px;" />
            <el-button v-if="isEdit" type="text" @click="openChose">选择定位</el-button>
            <el-button v-else type="text" @click="showMap">查看位置</el-button>
          </div>
        </el-descriptions-item>
      </el-descriptions>

    </div>
    <point-choose ref="choose1" :lnglat="lnglat" @ok="chooseOK" />

  </div>
</template>

<script>

import PointChoose from '@/components/Map/Choose'
export default {
  components: { PointChoose },
  data() {
    return {
      isEdit: false,
      // companyId: 0,
      companyData: {
        industry2017s: []
      },
      industry2017s: [],
      wasteManagement: [],

      industries: [],
      industriesProps: {
        multiple: true,
        value: 'industryCode',
        label: 'industryName',
        emitPath: false
      },
      types: [],
      editBeforeDataStr: "",
      businessCategory: [],
      date: [],
    }
  },
  props: {
    companyId: {
      default: 0
    }
  },
  watch: {
    companyId(val) {
      this.getAllData();
    }
  },

  computed: {
    size() {
      return this.isEdit ? 'mini' : ''
    },
    effDateTime() {

      const { startEffDateTime, endEffDateTime } = this.companyData;
      if (startEffDateTime) {
        return this.$dayjs(startEffDateTime).format('YYYY年MM月DD日') + "至" + this.$dayjs(endEffDateTime).format('YYYY年MM月DD日')
      } else {
        return ""
      }
    },
    lnglat() {
      return [this.companyData.lng, this.companyData.lat]
    },
  },
  methods: {
    openChose() {
      this.$refs.choose1.open()
    },
    chooseOK(lnglat) {
      this.companyData.lng = lnglat[0]
      this.companyData.lat = lnglat[1]
    },
    showMap() {
      this.$refs.choose1.detail()
      // this.dialogMapVisible = true
      // this.$refs.map1.addPoint([this.companyData.lng, this.companyData.lat], false)
    },

    getData() {
      let url = this.$api.companies.getUserCompany;

      let params = {};
      if (this.companyId) {
        params = { companyId: this.companyId }
      }
      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {
          let { company, industries, wasteManagement } = res.data.data;
          this.industry2017s = company.industry2017s.map(c => c.industryCode);

          //处理flags枚举
          let wasteManagementChecked = [];
          let wasteManagementShow = "";
          if (company.wasteManagement > 0) {
            let wastNames = [];
            wasteManagement.map(wast => {
              if (wast.Key === (company.wasteManagement & wast.Key)) {
                wasteManagementChecked.push(wast.Key);
                wastNames.push(wast.Value);
              }
            })
            wasteManagementShow = wastNames.join('、')
          }

          company.wasteManagementShow = wasteManagementShow;
          company.wasteManagementChecked = wasteManagementChecked;

          this.date = company.startEffDateTime ? [company.startEffDateTime, company.endEffDateTime] : null;

          this.businessCategory = company.businessCategory ? company.businessCategory.split('、') : [];
          this.companyData = company;
          this.industries = industries;
          this.wasteManagement = wasteManagement;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    dateChange(val) {
      if (val && val.length > 0) {
        this.companyData.startEffDateTime = val[0];
        this.companyData.endEffDateTime = val[1];
      } else {
        this.companyData.startEffDateTime = "";
        this.companyData.endEffDateTime = "";
      }
    },
    cancelEdit() {
      let { companyData, industry2017s, businessCategory, date } = JSON.parse(this.editBeforeDataStr);
      this.companyData = companyData;
      this.industry2017s = industry2017s;
      this.businessCategory = businessCategory;
      this.date = date;
      this.isEdit = false;
    },
    edit() {
      const data = { companyData: this.companyData, industry2017s: this.industry2017s, businessCategory: this.businessCategory, date: this.date };
      this.editBeforeDataStr = JSON.stringify(data);
      this.isEdit = true;
    },
    wasteManagementChange(val) {

      let wastNames = [];
      this.wasteManagement.map(wast => {
        if (val.includes(wast.Key)) {
          wastNames.push(wast.Value);
        }
      })
      this.companyData.wasteManagement = val.reduce((accumulator, currentValue) => {
        return accumulator + currentValue;
      }, 0);


      this.companyData.wasteManagementShow = wastNames.join('、')
    },
    businessCategoryChange(val) {
      this.companyData.businessCategory = val.join('、');
    },
    save() {

      let url = this.$api.companies.modifyCompany;
      let nodes = this.$refs.industryCas.getCheckedNodes(true);
      this.companyData.industry2017s = nodes.map(n => n.data);
      this.$axios
        .post(url, this.companyData, false)
        .then((res) => {
          if (res.data.code === 0) {
            this.isEdit = false
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addList() {
      this.dialogFormVisible = true
    },
    saveList() {
      this.$refs.listForm.validate((valid) => {
        if (valid) {
          let url = this.$api.dangerWasters.addDangerWasterList;
          this.$axios
            .post(url, this.form, false)
            .then((res) => {
              if (res.data.code === 0) {
                this.dialogFormVisible = false;
                this.form = {
                  name: '',
                  type: '',
                  code: '',
                  id: 0
                }
                this.getData()
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });

    },
    getTypes() {
      let url = this.$api.dangerWasters.getTypes;
      this.$axios.get(url, false).then((res) => {
        if (res.data.code == 0) {
          this.types = res.data.data.types;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },

    changeIndustry(data) {
      // this.companyData.industryCode = data.join(',')
      let nodes = this.$refs.industryCas.getCheckedNodes(true);
      let codes = []
      nodes.forEach((node) => {
        let { path, value } = node;
        if (data.includes(value)) {
          let l = path.length - 1;
          codes.push(path[0] + path[l])
        }
      })
      this.companyData.industryCode = codes.join('、');
    },

    getAllData() {
      this.getData();
      this.getTypes();
    }

  },
  mounted() {


    this.getAllData();
  },
}
</script>
<style lang="scss" scoped>
.title {
  font-size: 18px;
  font-weight: bold;
  border-left: 8px solid #1890ff;
  padding-left: 12px;
  color: #000;
}

/deep/.el-descriptions-item__content {
  max-width: 226px;
}

.basic-com {
  padding: 0px 5px;
}
</style>
